module.exports = __webpack_public_path__ + "img/bio1.7ba5eee6.jpg";